import i18n from '@/lib/i18n';

// TODO: 라이브러리 업데이트 후 admin-client와 동일한 인터페이스(DateTime + Temporal)로 통일
// 로직은 admin DateTime.fromNow()와 동일 (경과 시간 기준)
function daysToMonths(days) {
  return (days * 4800) / 146097;
}

function getLocale() {
  return i18n.locale === 'ko' ? 'ko-KR' : i18n.locale || 'ko-KR';
}

/**
 * Format a date string to relative date (경과 시간 기준, admin-client의 DateTime.fromNow()와 동일 로직)
 * @param {string} dateString - ISO date string
 * @returns {string} Relative date string
 */
export function formatRelativeDate(dateString) {
  if (!dateString) return '';

  const rtf = new Intl.RelativeTimeFormat(getLocale(), { numeric: 'auto' });

  const diffSeconds = (new Date(dateString).getTime() - Date.now()) / 1000;
  const sign = diffSeconds < 0 ? -1 : 1;

  const absSeconds = Math.abs(diffSeconds);
  if (absSeconds < 45)
    return rtf.format(sign * Math.round(absSeconds), 'second');

  const absMinutes = absSeconds / 60;
  if (absMinutes < 45)
    return rtf.format(sign * Math.round(absMinutes), 'minute');

  const absHours = absSeconds / 3600;
  if (absHours < 22) return rtf.format(sign * Math.round(absHours), 'hour');

  const absDays = absSeconds / 86400;
  if (absDays < 26) return rtf.format(sign * Math.round(absDays), 'day');

  if (absDays < 320) {
    const absMonths = daysToMonths(absDays);
    return rtf.format(sign * Math.round(absMonths), 'month');
  }

  const absYears = absSeconds / (86400 * 365);
  return rtf.format(sign * Math.round(absYears), 'year');
}

export default formatRelativeDate;
